import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { TextWidgetComponent } from './component/text-widget/text-widget.component';

@NgModule({
  imports: [
    CommonModule,
    ApplicationClientCommonModule
    
  ],
  declarations: [
    TextWidgetComponent
  ]
})
export class TextWidgetModule { }

